import { ref } from 'vue';

function useAdvancedSort(props) {
  const selectedSizes = ref([]);
  const min = ref(props.condition.PriceLow);
  const max = ref(props.condition.PriceHigh);
  const range = ref([props.condition.PriceLow, props.condition.PriceHigh]);
  getInitArgs();

  function getInitArgs() {
    const initSize = getTargetArgValue('S=').split(',');
    if (initSize[0].length !== 0) selectedSizes.value = initSize;
    if (getTargetArgValue('PL') !== '') {
      range.value = [getTargetArgValue('PL'), getTargetArgValue('PH')];
    }
  }

  function getTargetArgValue(arg) {
    let targetArg = '';
    if (window.location.search.length !== 0 && window.location.search.indexOf(arg) !== -1) {
      const args = window.location.toString().split('?')[1].split('&');
      args.forEach((element, index) => {
        if (element.indexOf(arg) !== -1) {
          targetArg = element;
        }
      });
    }
    return targetArg.length !== 0
      ? targetArg.substring(targetArg.indexOf('=') + 1, targetArg.length)
      : '';
  }

  function clearCondition() {
    selectedSizes.value = [];
    range.value = [min.value, max.value];
  }

  function addSize(size) {
    const index = selectedSizes.value.findIndex((e) => {
      return e === size.toString();
    });

    if (index >= 0) {
      selectedSizes.value.splice(index, 1);
    } else {
      selectedSizes.value.push(size.toString());
    }
  }

  function toggleSize(size) {
    const isSelected = selectedSizes.value.includes(size.toString());
    return {
      active: isSelected,
      '': !isSelected,
    };
  }

  function getPriceRangeArg() {
    const pl = range.value[0];
    const ph = range.value[1];
    return range.value !== [min.value, max.value] ? `PL=${pl}&PH=${ph}` : '';
  }

  function getSizeArg() {
    return selectedSizes.value.length !== 0 ? `S=${selectedSizes.value.toString()}` : '';
  }

  function goResult() {
    let argsString = '';

    if (window.location.search.length !== 0) {
      const args = window.location.toString().split('?')[1].split('&');
      let i = 0;

      while (i < args.length) {
        if (args[i].indexOf('PH') !== -1) {
          args.splice(i, 1);
        } else if (args[i].indexOf('PL') !== -1) {
          args.splice(i, 1);
        } else if (args[i].indexOf('S=') !== -1) {
          args.splice(i, 1);
        } else if (args[i].indexOf('P=') !== -1) {
          args.splice(i, 1);
        } else {
          i += 1;
        }
      }

      if (args.length !== 0) {
        if (selectedSizes.value.length !== 0 || range.value !== [min.value, max.value]) {
          argsString = `${args.join('&')}&`;
        } else {
          argsString = `${args.join('&')}`;
        }
      }
    }

    if (selectedSizes.value.length !== 0 || range.value !== [min.value, max.value]) {
      window.location.href = `${window.location.pathname}?${argsString}${getPriceRangeArg()}${
        getPriceRangeArg().length !== 0 && getSizeArg().length !== 0 ? '&' : ''
      }${getSizeArg()}`;
    } else if (argsString.length === 0) {
      window.location.href = window.location.pathname;
    } else {
      window.location.href = `${window.location.pathname}?${argsString}`;
    }
  }

  return {
    min,
    max,
    range,

    clearCondition,
    addSize,
    toggleSize,
    goResult,
  };
}

export default useAdvancedSort;
